import { GET_ACTIVE_FIRES_PENDING
    ,GET_ACTIVE_FIRES_FULFILLED
    ,GET_ACTIVE_FIRES_REJECTED
    ,REFRESH_ACTIVE_FIRES_PENDING
    ,REFRESH_ACTIVE_FIRES_FULFILLED
    ,REFRESH_ACTIVE_FIRES_REJECTED
    ,GET_LOCAL_FIRE_INFO_PENDING
    ,GET_LOCAL_FIRE_INFO_FULFILLED
    ,GET_LOCAL_FIRE_INFO_REJECTED
    ,REFRESH_LOCAL_FIRE_INFO_PENDING
    ,REFRESH_LOCAL_FIRE_INFO_FULFILLED
    ,REFRESH_LOCAL_FIRE_INFO_REJECTED
    ,GET_FIRE_PROPERTIES_PENDING
    ,GET_FIRE_PROPERTIES_FULFILLED 
    ,GET_FIRE_PROPERTIES_REJECTED 
    ,CLEAR_FIRE_PROPERTIES_PENDING
    ,CLEAR_FIRE_PROPERTIES_FULFILLED 
    ,CLEAR_FIRE_PROPERTIES_REJECTED
} from '../actions/fireActions.js';

import { getDistanceUnit, getWindDirection, getSpeedUnit } from '../../utilities/apiConversionUtil';

const initialState = {
    activeFiresIsRefreshing: false
    ,localFireInfoIsRefreshing: false
};

function getFireId(feature) {
    const { geometry } = feature;
    return geometry.type + ('' + geometry.coordinates[0]) + ('' + geometry.coordinates[1]);
}

export function fire(state = initialState, action)
{
    switch (action.type)
    {
        case GET_ACTIVE_FIRES_PENDING:
        {
            return {
                ...state
                ,activeFiresIsFetching: true
            };
        }
        case GET_ACTIVE_FIRES_FULFILLED:
        {
            const activeFires = action.payload;
            if (activeFires && activeFires.features) {
                
                activeFires.features.forEach(feature => {
                    const properties = feature.properties || {};
                    properties.id = getFireId(feature);
                    properties.latitude = feature.geometry.coordinates[1];
                    properties.longitude = feature.geometry.coordinates[0];
                    feature.properties = properties;
                });
            }
            return {
                ...state
                ,activeFires
                ,lastError: {},
                activeFiresIsFetching: false
            };
        }

        case GET_ACTIVE_FIRES_REJECTED:
        {
            return {
                ...state,
                activeFires: undefined
                ,lastError: action.payload
                ,activeFiresIsFetching: false
            };
        }

        case GET_FIRE_PROPERTIES_PENDING:
        {
            return {
                ...state
                ,getFirePropertiesIsFetching: true
            };
        }
        case GET_FIRE_PROPERTIES_FULFILLED:
        {
            //TECHDEBT: We should just set selectedFires to one fire instead of a feature collection
            //TECHDEBT: The API should return the translated property values instead of us converting them on the frontend
            const fires = action.payload;
            if (fires && fires.features) {
                fires.features.forEach(feature => {
                    const properties = feature.properties || {};
                    properties.id = getFireId(feature);
                    properties.latitude = feature.geometry.coordinates[1];
                    properties.longitude = feature.geometry.coordinates[0];
                    properties.distanceUnit = getDistanceUnit(properties.du);
                    properties.windSpeedUnit = getSpeedUnit(properties.wsu);
                    properties.windDirection = getWindDirection(properties.wd);
                    feature.properties = properties;
                });
            }
            return {
                ...state
                ,selectedFire: fires
                ,lastFirePropertiesError: {}
                ,getFirePropertiesIsFetching: false
            };
        }

        case GET_FIRE_PROPERTIES_REJECTED:
        {
            return {
                ...state,
                selectedFire: undefined
                ,lastFirePropertiesError: action.payload
                ,getFirePropertiesIsFetching: false
            };
        }
        case CLEAR_FIRE_PROPERTIES_PENDING:
        {
            return {
                ...state
                ,clearFirePropertiesIsPending: true
            };
        }
        case CLEAR_FIRE_PROPERTIES_FULFILLED:
        {
            return {
                ...state
                ,selectedFire: undefined
                ,lastFirePropertiesError: {},
                clearFirePropertiesIsPending: false
            };
        }

        case CLEAR_FIRE_PROPERTIES_REJECTED:
        {
            return {
                ...state,
                selectedFire: undefined
                ,lastFirePropertiesError: action.payload
                ,clearFirePropertiesIsPending: false
            };
        }

        case REFRESH_ACTIVE_FIRES_PENDING:
        {
            return {
                ...state
                ,activeFiresIsRefreshing: true
            };
        }

        case REFRESH_ACTIVE_FIRES_FULFILLED:
        {
            return {
                ...state,
                activeFires: action.payload
                ,lastError: {}
                ,activeFiresIsRefreshing: false
            };
        }

        case REFRESH_ACTIVE_FIRES_REJECTED:
        {
            return {
                ...state,
                activeFires: undefined
                ,lastError: action.payload
                ,activeFiresIsRefreshing: false
            };
        }

        case GET_LOCAL_FIRE_INFO_PENDING:
        {
            return {
                ...state
                ,localFireInfoIsFetching: true
            };
        }
        case GET_LOCAL_FIRE_INFO_FULFILLED:
        {
            return {
                ...state
                ,localFireInfo: action.payload
                ,lastError: {},
                localFireInfoIsFetching: false
            };
        }

        case GET_LOCAL_FIRE_INFO_REJECTED:
        {
            return {
                ...state,
                localFireInfo: undefined
                ,lastError: action.payload
                ,localFireInfoIsFetching: false
            };
        }

        case REFRESH_LOCAL_FIRE_INFO_PENDING:
        {
            return {
                ...state
                ,localFireInfoIsRefreshing: true
            };
        }

        case REFRESH_LOCAL_FIRE_INFO_FULFILLED:
        {
            return {
                ...state,
                localFireInfo: action.payload
                ,lastError: {}
                ,localFireInfoIsRefreshing: false
            };
        }

        case REFRESH_LOCAL_FIRE_INFO_REJECTED:
        {
            return {
                ...state,
                localFireInfo: undefined
                ,lastError: action.payload
                ,localFireInfoIsRefreshing: false
            };
        }
    }

    return state;
}